import PropTypes from 'prop-types';
import React from 'react';

function Select(props) {
  const { fill } = props;
  return (
    <svg
      height="24"
      style={{ fill: 'none' }}
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1231_126365)">
        <path
          d="M12 21.375C17.1777 21.375 21.375 17.1777 21.375 12C21.375 6.82233 17.1777 2.625 12 2.625C6.82233 2.625 2.625 6.82233 2.625 12C2.625 17.1777 6.82233 21.375 12 21.375Z"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
        <path
          d="M7 10.3335L11.837 15.2673C11.8574 15.2881 11.8824 15.3048 11.9105 15.3162C11.9386 15.3276 11.969 15.3335 11.9998 15.3335C12.0306 15.3335 12.061 15.3276 12.0891 15.3162C12.1171 15.3048 12.1422 15.2881 12.1626 15.2673L17 10.3335"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_1231_126365">
          <rect fill="white" height="20" transform="translate(2 2)" width="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

Select.propTypes = {
  fill: PropTypes.string.isRequired
};

export default Select;
